<template>
  <div class="helpdesk">
    <a href="https://bit.ly/4dOYcng" target="_blank" @click="trackClick">
      <i class="material-icons">help</i> Central de Ajuda
    </a>
  </div>
</template>

<script>
export default {
  name: "Helpdesk",
  methods: {
    trackClick() {
      window.woopra.track("helpdesk-clicked", { path: this.$route.path });
    }
  }
}
</script>

<style scoped>
  .helpdesk {
    padding: 16px;
    /* margin-left:-40px; */
    text-align: center;
    a {
      color: #5E6C84;
      font-size: 16px;
      font-family: Roboto;
      font-weight: 700;
      line-height: 19.20px;
      letter-spacing: 0.32px;
      word-wrap: break-word;
      display: flex;
      align-items: center;
      gap: 4px;
      i {
        font-size: 18px;
      }
    }
  }
</style>



